import { currencyFormatter, formatPrintDate, formatLongDate } from './utils'

export function combineRatings(ratings, isCombined) {
  var result = 0.0;
  if (isCombined) {
    var sorted = ratings.slice();
    sorted.sort( (a,b) => (b.rating-a.rating) );

    result = parseFloat(sorted[0].rating);
    for (var i = 1; i < sorted.length; ++i) {
      let rating = parseFloat(sorted[i].rating);

      result = (1.0 - result/100.0) * rating + result;
      result = Math.round(result);
    }
  }
  else {
    for (var i = 0; i < ratings.length; ++i)
      result = parseFloat(ratings[i].rating) + result;
    if (result > 100.0)
      result = 100.0;
  }
  return result | 0;
}

export function getRatingsString(state) {
  var result = '';
  let birth = new Date(state.ratings[0].birth);
  let injury = new Date(state.ratings[0].injury);
  result = `DATE OF BIRTH: ${formatLongDate(birth)}`;
  result += `\nDATE OF INJURY: ${formatLongDate(injury)}`;

  let occGroup = state.ratings[0].occGroupDescription;
  if ( occGroup != null )
    result += `\n\nOCCUPATIONAL GROUP: ${occGroup}`;
  else
    result += `\n\nOCCUPATION: ${state.ratings[0].occupationDescription}`;
  result += '\n';
  result += getTailString(state);
  result += "\n\n";
  // result += "--------------------------------------------------------------\nCompCalc Plus: “the Complex made Simple ...”\n";

  return result;
}

function getTailString(state) {
  var result = '\n';

  for (var i=0; i < state.ratings.length; ++i) {
    let bodyDetailDescription = state.ratings[i].bodyDetailDescription;
    let apportionment = state.ratings[i].apport;
    result += `RATING #${i+1}\n    PART OF BODY: ${bodyDetailDescription}\n    WHOLE PERSON IMPAIRMENT: ${state.ratings[i]['wpi']}%\n`;

    if ( (0 <= apportionment) && (apportionment < 100) )
      result += `    APPORTIONMENT: ${apportionment}%\n`;

    result += '\n';
  }

  for (var i=0; i < state.ratings.length; ++i)
    result += `RATING STRING #${i+1}: ${state.ratings[i].ratingString}\n`;

  result += '\n';

  if (state.isManualAww) {
    result += `WORK PERIOD START\tWORK PERIOD END\tWAGE\n\n`;
    state.awwArray.forEach(row => {
      result += `${formatPrintDate(row.startDate)}\t${formatPrintDate(row.endDate)}\t${row.wage}\n`;
    });
    result += '\n';
  }

  if (state.aww) {
    result += `AVERAGE WEEKLY WAGE: ${state.aww}\n`;
    result += `${state.pdRateText.toUpperCase()}: ${state.pdRate}\n`;
  }

  if (state.ratings.length > 1)
    result += "\nCOMBINED VALUE: ";
  else
    result += "\nADJUSTED PD: ";

  result += `${state.combinedValue}%`;

  if (state.combinedValue != 100)
    result += `\nAMOUNT: ${currencyFormatter.format(state.amount)}`;
  return result;
}
